__turbopack_context__.v({
  "answer": "Faq-module__53FxXG__answer",
  "faq": "Faq-module__53FxXG__faq",
  "item": "Faq-module__53FxXG__item",
  "question": "Faq-module__53FxXG__question",
});
